import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {delay, filter, map, mergeMap} from "rxjs/operators";
import {FileService} from "../services/file.service";
import Swal from "sweetalert2";
import {saveAs as importedSaveAs} from "file-saver";


@Component({
  selector: 'app-main-list',
  templateUrl: './main-list.component.html',
  styleUrls: ['./main-list.component.css']
})
export class MainListComponent implements OnInit {

  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  public isDownloading: boolean;
  isDesktop:boolean;
  message: any = 'File Downloaded';
  src:any;
  fileName:any;
  constructor(private route: ActivatedRoute, private file: FileService, private router: Router) { }


  removeHash () {
    history.pushState("", document.title, window.location.pathname
      + window.location.search);
  }

  ngOnInit(): void {
    this.isDesktop = this.file.getMobileOperatingSystem() === 'Desktop';
    this.removeHash();
    this.route.queryParams.pipe(mergeMap(({storagePath, fileName, dataSource} : any) => {
      this.isDownloading = true;
      let encodedPath = "";
      if(dataSource === "1"){
         encodedPath = `/api/services/app/TkeJobFiles/DownloadFile?storagePath=${encodeURIComponent(storagePath)}&fileName=${encodeURIComponent(fileName)}`;
      }
      else{
         encodedPath = `/api/services/app/TkeJobFiles/DownloadFileFromBlob?storagePath=${encodeURIComponent(storagePath)}&fileName=${encodeURIComponent(fileName)}&isViewOrCopy=${encodeURIComponent(true)}`;
      }
      return this.file.postCallToDownloadFile(encodedPath).pipe(map((blob) => ({storagePath, fileName, blob})))
    }))
      .subscribe(({storagePath, fileName, blob}) => {
        this.isDownloading = false;
        if (fileName.toUpperCase().indexOf('PDF') <= -1) {
          importedSaveAs(blob, fileName);
        } else {
          this.src = URL.createObjectURL(blob);
          this.fileName = fileName;
        }
      }, () => {
        Swal.fire({
          icon: 'error',
          title: '',
          text: `Error Downloading file`
        });
        this.message = 'Error Downloading File';
        this.isDownloading = false;
      });

  }

  navigateToHome() {
    this.router.navigate(['/']);
  }
}
